import React, { useCallback, useState } from "react";
import { Form, Input, Checkbox } from "antd";
import { useIntl } from "react-intl";

import InfoLabel from "../../app/generic/infoLabel";

const { Item } = Form;

function TemplateForm({ form, consignment, templateWork, setSaveWhat }) {
  const { getFieldDecorator } = form;
  const intl = useIntl();

  const [showName, setShowName] = useState(templateWork);
  const handleChange = useCallback(
    (e) => {
      setShowName(e.target.checked);
      setSaveWhat(
        e.target.checked
          ? intl.formatMessage({
              id: "consignment.template.whom",
              defaultMessage: "šablonu",
            })
          : intl.formatMessage({
              id: "consignment.whom",
              defaultMessage: "zásilku",
            })
      );
    },
    [intl, setSaveWhat]
  );

  return (
    <Form layout="inline">
      <Item>
        {getFieldDecorator("template", {
          initialValue: showName,
          valuePropName: "checked",
        })(
          <Checkbox onChange={handleChange} disabled={templateWork}>
            {intl.formatMessage({
              id: "consignment.saveAsTemplate",
              defaultMessage: "Uložit zásilku jako šablonu ",
            })}
            <InfoLabel
              info={intl.formatMessage({
                id: "consignment.saveAsTemplateInfo",
                defaultMessage:
                  "Na základě dat ze šablony zásilky můžete vytvářet nové zásilky. Při uložení šablony nedojde současně k vytvoření zásilky!",
              })}
            />
          </Checkbox>
        )}
      </Item>
      {showName && (
        <Item>
          {getFieldDecorator("templateName", {
            initialValue:
              (templateWork && consignment && consignment.templateName) || "",
            rules: [
              {
                required: true,
                message: intl.formatMessage({
                  id: "consignment.emptyTemplateName",
                  defaultMessage: "Zadejte prosím název šablony!",
                }),
              },
            ],
          })(
            <Input
              allowClear
              placeholder={intl.formatMessage({
                id: "consignment.templateName",
                defaultMessage: "název šablony",
              })}
            />
          )}
        </Item>
      )}
    </Form>
  );
}

export default Form.create()(TemplateForm);
